import React from "react";

import { Segment, Header, SegmentProps } from "semantic-ui-react";

interface BlockHeaderProps {}

type props = BlockHeaderProps & SegmentProps;

export const BlockHeader: React.FC<props> = ({ children, ...props }) => {
  return (
    <Segment inverted compact {...props}>
      <Header inverted as="h2">
        {children}
      </Header>
    </Segment>
  );
};

export default BlockHeader;
